module.exports = __webpack_public_path__ + "img/collection-weddingRingsBudgetMedium@2x.3319007.webp";